/**
 * Generates a UUID for the enabledElement.
 * https://stackoverflow.com/a/8809472/9208320 Public Domain/MIT
 *
 * @returns {string} the UUID.
 */
function generateUUID() {
  let d = Date.now();

  if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
    d += performance.now(); // Use high-precision timer if available
  }

  return 'x.x.x.x.x.x.xxxx.xxx.x.x.xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx'.replace(
    /[xy]/g,
    (c) => {
      const r = Math.trunc((d + Math.random() * 16) % 16);

      d = Math.floor(d / 16);

      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    },
  );
}

export default generateUUID;
